import { ACTIVE_KANBAN_STAGE_IDS, REFUSED_MATCH_STATUSES } from "@/components/jobs/kanban/types/index";

const ALL_VALID_MATCH_STATUSES: readonly string[] = [...ACTIVE_KANBAN_STAGE_IDS, ...REFUSED_MATCH_STATUSES];

const isValidMatchStatus = (status: string): boolean => {
	return ALL_VALID_MATCH_STATUSES.includes(status);
};

const MATCH_TIMELINE_TRANSITIONS: Record<string, readonly string[]> = {
	applied: ['matched', 'application_closed', 'candidate_not_available'],
	matched: ['screening', 'candidate_not_interested', 'application_closed', 'candidate_not_available'],
	screening: ['sent', 'candidate_not_interested', 'rejected_by_recruter', 'application_closed', 'candidate_not_available'],
	sent: ['interview', 'rejected_by_customer', 'rejected_by_recruter', 'application_closed', 'candidate_not_available'],
	interview: ['offer', 'rejected_by_customer', 'rejected_by_recruter', 'application_closed', 'candidate_not_available'],
	offer: ['hired', 'offer_rejected_by_candidate', 'application_closed', 'candidate_not_available'],
	hired: []
};

export const isClosedTimelineStatus = (status?: string | null): boolean => {
	if (!status)
		return false;

	return REFUSED_MATCH_STATUSES.includes(status as typeof REFUSED_MATCH_STATUSES[number]);
};

export const getAllowedNextTimelineStatuses = (status?: string | null, previousStatus?: string | null): string[] => {
	if (!status)
		return [...MATCH_TIMELINE_TRANSITIONS.matched];

	if (isClosedTimelineStatus(status)) {
		if (!previousStatus || !isValidMatchStatus(previousStatus))
			return [];

		return [previousStatus];
	}

	return [...(MATCH_TIMELINE_TRANSITIONS[status] || [])];
};

export const isActiveTimelineStage = (status: string): boolean => {
	return ACTIVE_KANBAN_STAGE_IDS.includes(status as typeof ACTIVE_KANBAN_STAGE_IDS[number]);
};